// Pure placement maths for Sign PDF (SIGN-04): a field is centred on the point the person clicked.

/** Largest size that fits inside the box while keeping the image's shape (height / width = aspect). */
export function fitContain(boxW: number, boxH: number, aspect: number): { width: number; height: number } {
  if (!(boxW > 0) || !(boxH > 0) || !(aspect > 0)) return { width: Math.max(0, boxW), height: Math.max(0, boxH) };
  let width = boxW;
  let height = width * aspect;
  if (height > boxH) { height = boxH; width = height / aspect; }
  return { width, height };
}

/** Bottom-left corner (viewed page, y up) of a width x height rectangle centred on the click point. */
export function centredOrigin(centerX: number, centerY: number, width: number, height: number): { x: number; y: number } {
  return { x: centerX - width / 2, y: centerY - height / 2 };
}

/** Click fractions (origin top-left) to a point in page points with y up. */
export function clickToPagePoint(xFrac: number, yFrac: number, pageW: number, pageH: number): { x: number; y: number } {
  return { x: xFrac * pageW, y: pageH - yFrac * pageH };
}

/** Why Download can't run yet, or null when it can. Never a silent no-op. */
export function signBlocker(fields: { xFrac: number | null }[]): string | null {
  if (fields.length === 0) return "Tap where you want to sign: add a Signature field above, then click the page.";
  const unplaced = fields.filter((f) => f.xFrac === null).length;
  if (unplaced > 0) return `Place all fields on the page first (${unplaced} not yet placed).`;
  return null;
}
